import { render, staticRenderFns } from "./ActionCenterChips.vue?vue&type=template&id=2f891832&scoped=true"
import script from "./ActionCenterChips.vue?vue&type=script&lang=js"
export * from "./ActionCenterChips.vue?vue&type=script&lang=js"
import style0 from "./ActionCenterChips.vue?vue&type=style&index=0&id=2f891832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f891832",
  null
  
)

export default component.exports